module.exports = __webpack_public_path__ + "static/img/小程序-小程序开发.9a0f95a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/goods/CPK10007/小程序-小程序开发.png
// module id = 1cN4
// module chunks = 1